<div class="cardStack clickable" id="Box_{{ label }}" routerLink="/{{ link }}">
    <div class="card2"></div>
    <div class="card1"></div>
    <div class="title">{{ label }}</div>
    <div class="icon {{ iconStyle }}"></div>
    <div class="subtitle">{{ count }}</div>
</div>
